import { autoinject, containerless } from 'aurelia-framework';
import { detect } from 'detect-browser';

import { BaseViewModel } from '~/base-view-model';

@autoinject
@containerless
export class BrowserCheck extends BaseViewModel {
	public static SUPPORTED_BROWSERS = ['chrome', 'edge-chromium'];

	private browserName: string;
	private isNotSupportedBrowser: boolean;
	private isWindowsOS: boolean;

	public attached() {
		this.browserName = detect().name;
		this.isNotSupportedBrowser = BrowserCheck.checkIfSupportedBrowser();
		this.isWindowsOS = detect().os.startsWith('Windows');
	}

	public static checkIfSupportedBrowser(): boolean {
		return BrowserCheck.SUPPORTED_BROWSERS.indexOf(detect().name) < 0;
	}
}
